import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=e5f208fc"
import script from "./Admin.ts?vue&type=script&lang=ts&external"
export * from "./Admin.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports